import { UserCapabilities } from '../../api'
import { getAllEnumOptions } from '../enum'

export const getAllCapabilities = () => getAllEnumOptions(UserCapabilities)

export const getCapabilityLabel = (key?: UserCapabilities) => {
  if (key === null || typeof key === 'undefined') return ''

  return UserCapabilities[key]
}
